import { render, staticRenderFns } from "./statuses.vue?vue&type=template&id=49189e7c&scoped=true&"
import script from "./statuses.vue?vue&type=script&lang=js&"
export * from "./statuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49189e7c",
  null
  
)

export default component.exports